/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAgreementUpdateMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  agreementParams: Types.IAgreementUpdateParams;
}>;

export type IAgreementUpdateMutation = {
  __typename?: 'Mutation';
  agreementUpdate?: {
    __typename?: 'AgreementUpdatePayload';
    success: boolean;
    errors?: Array<string> | null;
    escrow?:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          agreementSettingsConfigured: boolean;
          agreement: {
            __typename?: 'Agreement';
            protectionPeriod?: Types.ProtectionPeriodEnum | null;
            agreementForm?: Types.AgreementFormEnum | null;
            id: string;
            jurisdiction?: Types.JurisdictionEnum | null;
            liability?: Types.LiabilityEnum | null;
            approvedByBeneficiary?: boolean | null;
            approvedByCodekeeper?: boolean | null;
            approvedByDepositor?: boolean | null;
            thirdPartyAgreement: boolean;
            updatedAt: any;
            legalContext: Array<Types.LegalContextEnum>;
            legalContextOther?: string | null;
            approved: boolean;
            conditions: Array<Types.AgreementConditionEnum>;
            conditionsOther?: string | null;
            policy: {
              __typename?: 'AgreementPolicy';
              approve: boolean;
              generate: boolean;
              write: boolean;
              download: boolean;
            };
          };
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          agreementSettingsConfigured: boolean;
          agreement: {
            __typename?: 'Agreement';
            protectionPeriod?: Types.ProtectionPeriodEnum | null;
            agreementForm?: Types.AgreementFormEnum | null;
            id: string;
            jurisdiction?: Types.JurisdictionEnum | null;
            liability?: Types.LiabilityEnum | null;
            approvedByBeneficiary?: boolean | null;
            approvedByCodekeeper?: boolean | null;
            approvedByDepositor?: boolean | null;
            thirdPartyAgreement: boolean;
            updatedAt: any;
            legalContext: Array<Types.LegalContextEnum>;
            legalContextOther?: string | null;
            approved: boolean;
            conditions: Array<Types.AgreementConditionEnum>;
            conditionsOther?: string | null;
            policy: {
              __typename?: 'AgreementPolicy';
              approve: boolean;
              generate: boolean;
              write: boolean;
              download: boolean;
            };
          };
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          agreementSettingsConfigured: boolean;
          agreement: {
            __typename?: 'Agreement';
            protectionPeriod?: Types.ProtectionPeriodEnum | null;
            agreementForm?: Types.AgreementFormEnum | null;
            id: string;
            jurisdiction?: Types.JurisdictionEnum | null;
            liability?: Types.LiabilityEnum | null;
            approvedByBeneficiary?: boolean | null;
            approvedByCodekeeper?: boolean | null;
            approvedByDepositor?: boolean | null;
            thirdPartyAgreement: boolean;
            updatedAt: any;
            legalContext: Array<Types.LegalContextEnum>;
            legalContextOther?: string | null;
            approved: boolean;
            conditions: Array<Types.AgreementConditionEnum>;
            conditionsOther?: string | null;
            policy: {
              __typename?: 'AgreementPolicy';
              approve: boolean;
              generate: boolean;
              write: boolean;
              download: boolean;
            };
          };
        }
      | null;
  } | null;
};

export const AgreementUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'agreementUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agreementParams' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AgreementUpdateParams' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'agreementParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'agreementParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agreementSettingsConfigured' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EscrowAgreementFields' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'protectionPeriod' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EscrowAgreementFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Agreement' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jurisdiction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'liability' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByBeneficiary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByCodekeeper' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approvedByDepositor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'thirdPartyAgreement' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalContext' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalContextOther' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'approve' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'write' } },
                { kind: 'Field', name: { kind: 'Name', value: 'download' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conditions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conditionsOther' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAgreementUpdateMutation, IAgreementUpdateMutationVariables>;
